/* WebComponentLabelPrintingPrintTsx template */
import { h } from '@stencil/core';
import {WebComponentLabelPrinting} from "../webComponentLabelPrinting";

const WebComponentLabelPrintingPrintTsx = (context) => {
  let I18N = context.ref.I18N;

  return (
      <dia-grid-nested>
        <dia-grid-row data-printing-preview>
          <dia-grid-column>
            <dia-form>
              { /* @ts-ignore */}
              <form action="#" method="GET" name="dia-label-printing-print" has="validator">
                <dia-form-line data-form-line-no-wrap>
                  <dia-form-control>
                    <input type="hidden" data-rules="required" name="max-label-count" value={context.ref.printPageMaxLabelCountPerSheet} />
                    <select autocomplete="off" data-rules="required" name="label-id"
                            onChange={(event) => context.ref.changePdfPreview(event.target)}
                            data-validator-message-show="error"
                            data-validator-message-required={context.ref.labelOverviewData && context.ref.labelOverviewData.data && context.ref.labelOverviewData.data.length === 0 ? I18N.t('Bitte legen Sie ein Etikett an!') : I18N.t('Bitte wählen Sie ein Etikett aus')}>
                      <option value="" disabled selected hidden></option>
                      {context.ref.labelOverviewData && context.ref.labelOverviewData.data ? context.ref.labelOverviewData.data.map((entry) =>
                          <option value={entry.labelId} data-template={entry.templateId}>{entry.labelDesc}</option>
                      ) : ''}
                    </select>
                    <label>{ I18N.t('Etikett') }</label>
                  </dia-form-control>
                </dia-form-line>
                <dia-form-line data-form-line-no-wrap>
                  <dia-form-control>
                    <input autocomplete="off"
                        data-rules="required|number|min:1|max:max-label-count"
                        type="text"
                        name="start-position"
                        placeholder=""
                        defaultValue="1"
                        value={WebComponentLabelPrinting.PARAMETERS && WebComponentLabelPrinting.PARAMETERS['start-position'] || "1"}
                        onKeyUp={(event) => context.ref.changePdfPreview(event.target)}
                        readonly={!context.ref.printLabelTemplateChoosen}
                        data-validator-message-required={context.ref.printLabelTemplateChoosen ? I18N.t("Dieses Feld ist erforderlich") : I18N.t("Bitte wählen Sie zuerst ein Etikett")}
                    />
                    <label>{ I18N.t('Startposition (Etikett)') }</label>
                  </dia-form-control>
                </dia-form-line>
                <dia-form-line data-form-line-no-wrap>
                  <dia-form-control>
                    <input autocomplete="off"
                        data-rules="required|number|min:1"
                        type="text"
                        name="labels-per-article"
                        placeholder=""
                        defaultValue="1"
                        onKeyUp={(event) => context.ref.changePdfPreview(event.target)}
                        readonly={!context.ref.printLabelTemplateChoosen}
                        data-validator-message-required={context.ref.printLabelTemplateChoosen ? I18N.t("Dieses Feld ist erforderlich") : I18N.t("Bitte wählen Sie zuerst ein Etikett")}
                    />
                    <label>{ I18N.t('Etiketten pro Artikel') }</label>
                  </dia-form-control>
                </dia-form-line>
              </form>
            </dia-form>
          </dia-grid-column>
          <dia-grid-column>
            <dia-panel>
              <dia-panel-content>
                <picture>
                  {context.ref.pdfPreview && context.ref.pdfPreview.preview ?
                      <img data-labelprint-preview src={context.ref.pdfPreview.preview}/> :
                      <img data-printing-preview-placeholder src={context.ref.getComponentAssetPath("/images/logo.svg")}
                           alt={ I18N.t('Platzhalter') } height="150"/>}
                </picture>
              </dia-panel-content>
            </dia-panel>
            <dia-form>
              <dia-form-line data-label-print-info>
                <small>{ I18N.t('Ausgewählte Artikel') } {(context.ref.pdfPreview && context.ref.pdfPreview.articlesCount) || 0}</small>
                <small>{ I18N.t('Anzahl Etiketten') } {context.ref.pdfPreview ? context.ref.pdfPreview.printLabelsCount : '-'}</small>
                <small>{ I18N.t('Benötigte Seiten') } {context.ref.pdfPreview ? context.ref.pdfPreview.printTemplatesCount : '-'}</small>
                <small><strong>{ I18N.t('Benötigte Druckvorlage') } <br />{context.ref.pdfPreview ? context.ref.pdfPreviewTemplate : '-'}</strong></small>
              </dia-form-line>
              <dia-form-line data-form-line-no-wrap>
                <dia-form-control>
                  <button
                    data-primary
                    data-icon-only
                    title={ I18N.t('Zurück zur Druckliste') }
                    onClick={ () => context.ref.pushRouterRoute(context.ref.getRouterRoute('PRINTLIST')) }
                  >
                    <i data-dia-icon-before="previous"></i>
                  </button>
                </dia-form-control>
                <dia-form-control>
                  <button
                      data-primary
                      data-icon-only
                      title={ !context.ref.labelPrintingPrintFormValid ? I18N.t('Bitte füllen Sie alle benötigten Angaben korrekt aus!') : I18N.t('Vorschau & Drucken') }
                      disabled={ !context.ref.labelPrintingPrintFormValid }
                      onClick={ () => context.ref.printPDF() }
                  >
                    <i data-dia-icon-before="print"></i>
                  </button>
                </dia-form-control>
              </dia-form-line>
            </dia-form>
          </dia-grid-column>
        </dia-grid-row>
      </dia-grid-nested>
  )
};

export default WebComponentLabelPrintingPrintTsx;

